import React, { useEffect } from 'react';
import { Card, Form, Button, Row, Col, Image, Alert } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import Layout from '../layouts/Layout';
import ClarityLogo from '../assets/images/clarity-logo.png';

function TokenHandler({requestType}) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const parseParams = (search, hash) => {
      const params = new URLSearchParams(search || '');
      // also support tokens in hash (#id_token=...)
      if (!params.get('id_token') && hash) {
        // hash might be "#id_token=...&state=..."
        const cleaned = hash.startsWith('#') ? hash.slice(1) : hash;
        const hashParams = new URLSearchParams(cleaned);
        return hashParams;
      }
      return params;
    };
  
    const handleToken = () => {
      try {
        console.log('Redirect URL:', window.location.href);
        console.log('location.search:', window.location.search);
        console.log('location.hash:', window.location.hash);
  
        const params = parseParams(window.location.search, window.location.hash);
        const rawToken = params.get('id_token');
  
        if (!rawToken) {
          console.error('No id_token found in query or hash');
          return;
        }
  
        // decode safely (frontend decode only, no verification)
        const decodedToken = jwtDecode(rawToken);
        const email = decodedToken.email || decodedToken.preferred_username || decodedToken.upn;
        const firstName = decodedToken.first_name || decodedToken.given_name || '';
        const lastName = decodedToken.last_name || decodedToken.family_name || '';
  
        sessionStorage.setItem('bearerToken', rawToken);
        sessionStorage.setItem('username', email || '');
        sessionStorage.setItem('firstname', firstName);
        sessionStorage.setItem('lastName', lastName);
        sessionStorage.setItem('decodedToken', JSON.stringify(decodedToken, null, 2));
  
        // remove token from URL to avoid leaking in referer/history
        // build a clean path without query/hash
        const cleanPath = window.location.pathname;
        window.history.replaceState({}, document.title, cleanPath);
  
        // decide where to navigate
        if (requestType === 'Admin') {
          sessionStorage.setItem('adminSession', 'active');
          navigate('/Admin', { replace: true });
        } else {
          navigate('/Dashboard', { replace: true });
        }
      } catch (e) {
        console.error('Token handling failed:', e);
      }
    };
  
    handleToken();
  }, [location, navigate]);
  
  return (
    <Layout>
      <div className="confirmation-container mt-5">
        <Card className="confirmation-card shadow-lg p-3 mb-5 bg-white rounded">
          <div className="text-center mb-4">
            <Image src={ClarityLogo} alt="Company Logo" className="confirmation-logo" />
          </div>

          <Alert variant="danger" className="text-center">Please login from the portal</Alert>



        </Card>
      </div>
    </Layout>
  );
}

export default TokenHandler;
